export default "__VITE_ASSET__c005d0ed__"